import React from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useState} from 'react'
import data7 from '../choice'
import { addItem } from '../store'
import { useDispatch } from 'react-redux'
import ModalBasic from '../components/ModalBasic'




const Detail = (props) => {
  let { id } = useParams();
  const { soap, hand, incense } = props
  let dispacth = useDispatch();
  let selproduct = soap.find((x) => x.id == id)
  let choice = data7

  if ((id + 1) % 3 === 0) {
    choice = choice.hand
  } else if ((id + 1) % 3 === 1) {
    choice = choice.candle
  } else {
    choice = choice.gift
  }

  const [modalOpen, setModalOpen] = useState(false);
  const showModal = () => {
    setModalOpen(true);
    showModal();
  };

  const btnclick = () => {
    dispacth(addItem({ id: selproduct.id, item: selproduct.title, imgUrl: selproduct.imgUrl, price: selproduct.price, amount: 1 }));
    setModalOpen(true)

  }


  return (


    <Container>
      <div>
        {modalOpen && <ModalBasic setModalOpen={setModalOpen} />}
      </div>
      <Row>
        <Col md={7}>
          <img src={process.env.PUBLIC_URL + selproduct.imgUrl} width="100%" alt="" />
        </Col>
        <Col md={5} className='coldetail'>

          <h3 className='pt-5 detail'>{selproduct.title}</h3>
          <p className='detail-p'>{selproduct.content}</p>
          <p className='detail-p-2'>{selproduct.price}원</p>
          <h6 className='texthand'>{selproduct.text}</h6>
          <button className='cart' onClick={btnclick}>장바구니</button>

        </Col>



      </Row>



      <div className="object2">
        <Row>
          <h4 className='text-start'>추천 상품</h4>
          {
            choice.map((value, i) =>
              <Col md={3} key={i}>
                <img src={process.env.PUBLIC_URL + value.imgUrl} width="100%" alt="" />
                <h4>{value.title}</h4>
                <h6>{value.content}</h6>
                <h6>{value.price}</h6>
              </Col>
            )
          }
        </Row>
      </div>


    </Container>



  )
}
export default Detail